import api from './api';

export interface Rating {
  id: string;
  contentPageId: string;
  userId: string;
  rating: number;
  createdAt: string;
  updatedAt?: string;
}

export interface AverageRating {
  average: number;
  count: number;
}

export interface CreateRatingParams {
  contentPageId: string;
  rating: number; // 1-10
}

export const ratingService = {
  /**
   * Get average rating for a content page
   */
  async getAverage(contentPageId: string): Promise<AverageRating> {
    return api.get(`/ratings/average?contentPageId=${contentPageId}`);
  },

  /**
   * Get user's rating for a content page
   */
  async getUserRating(contentPageId: string): Promise<Rating | null> {
    try {
      return await api.get(`/ratings/user?contentPageId=${contentPageId}`);
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  /**
   * Create or update rating
   */
  async createOrUpdate(params: CreateRatingParams): Promise<Rating> {
    return api.post('/ratings', params);
  },

  /**
   * Delete rating
   */
  async delete(contentPageId: string): Promise<void> {
    return api.delete(`/ratings?contentPageId=${contentPageId}`);
  },
};

